<template>
 <div class="delivery-details">
    <div class="section-row">
        <div class="section-row-header">
            {{ resources.orderConfirmationHeader }}
        </div>

        <div v-for="(row, index) in contactRows" :key="index"
            :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
            <vue-input v-for="element in row" :key="element.id" :element="element"
                @blur="updateFieldValue(element.id, $event.target.value)"/>
        </div>
    </div>

    <template v-if="showPhoneRow">
        <div class="section-row">
            <div class="section-row-header">
                {{ resources.phoneChoiceHeader }}
            </div>
            <div v-for="(row, index) in phoneChoiceRows" :key="index"
            :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                <vue-input v-for="element in row" :key="element.id"
                    :element="element" @blur="updateFieldValue(element.id, $event.target.value)"/>
            </div>
        </div>
    </template>

    <template v-if="!hasSavedAddress && isHomeDelivery">
        <div class="section-row">
            <div class="section-row-header">
                {{ resources.addressDetailsHeader }}
            </div>
            <div v-for="(row, index) in namesRows" :key="index"
            :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                <vue-input v-for="element in row" :key="element.id"
                    :element="element" @blur="updateFieldValue(element.id, $event.target.value)"/>
            </div>
        </div>

        <div class="section-row" v-if="addressSearchRow && addressFieldsHidden">
            <div class="vue-form-row">
                <vue-input :element="addressSearchRow[0]" />
            </div>
        </div>

        <div v-if="addressFieldsHidden && hiddenRows" class="reveal-hidden" @click="addressFieldsHidden = false; enableEditShipping = true">
            {{ resources.enterAddressCTA }}
        </div>

        <div v-if="!addressFieldsHidden && hiddenRows" class="section-row">
            <div v-for="(row, index) in hiddenRows" :key="index"
                :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                <vue-input v-for="element in row" :key="element.id"
                    :element="element" @blur="updateFieldValue(element.id, $event.target.value)"/>
            </div>
        </div>
    </template>
 </div>
</template>
<script src="./delivery-details.js"/>
